import React, { FC } from 'react';

import { CDashboard } from 'components/Visualization';

import { ec2SummaryWidgets } from './config';

export const EC2Summary: FC = () => {
  return <CDashboard dashboardWidgets={ec2SummaryWidgets} />;
};
